<template>
    <aside class="layout_menu" :class="{ active: isSideMenu }">
        <div class="logo_box">
            <router-link to="/dash-board" @click="changeSideMenu(menuList[0])">
                <i class="logo">risingX Daily Briefing</i>
            </router-link>
            <button type="button" class="menu_close" @click="changeSideMenu(null)"></button>
        </div>
        <ul class="menu_inner">
            <li class="menu_item" v-for="menu in menuList" 
              :key="menu.key" 
              :class="{ active: menu.path == currentPath}" 
              @click="changeSideMenu(menu)">
                <i :class="['ti', menu.icon]"></i>
                <span>{{menu.label}}</span>
            </li>
        </ul>
    </aside>
    <div class="layout_overlay"></div>
    <modal-alert 
    :is-visible="alertDialog.isVisible" 
    :content="alertDialog.content" 
    :is-btn="true"
    @closeDialogHandler="alertCloseHandler" />
</template>

<script setup>
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import ModalAlert from "@/components/modal/ModalAlert.vue";
import { useLocalStorage } from "@/composables/useLocalStorage";
const router = useRouter();
const store = useStore();
const route = useRoute();
const isSideMenu = computed(() => store.state.menuList.isSideMenu);
const menuList   = computed(()=>store.getters["menuList/menuList"]);
const alertDialog = ref({
  isVisible: false,
  content: "",
});
const currentPath = computed(()=>route.path);
const changeSideMenu = (menu) => {
    const role = useLocalStorage("role");
    if(role.value == 2 && menu.is_role){
        alertDialog.value.content = "접근 권한이 없습니다.";
        alertDialog.value.isVisible = true;
        return;
    }
    if(menu){
        router.push(menu.path);
    }
    store.commit("menuList/setSideMenu", false);
};
const alertCloseHandler = () => {
  alertDialog.value.isVisible = false;
}
</script>

<style scoped></style>